type NotificationLike = {
  message: string;
  type?: string;
  name?: string;
  senderName?: string;
};

function senderName(input: NotificationLike): string {
  return String(input.name || input.senderName || '').trim();
}

/** Human-readable bell text — never show raw chat bodies for message alerts. */
export function formatNotificationDisplayMessage(input: NotificationLike): string {
  const message = String(input.message || '').trim();
  const type = String(input.type || '')
    .trim()
    .toLowerCase();
  const sender = senderName(input);

  if (/^you have a new message from /i.test(message)) {
    return message.endsWith('.') ? message : `${message}.`;
  }

  const newMessageFromMatch = message.match(/^new message from (.+?)\.?$/i);
  if (newMessageFromMatch?.[1]) {
    return `You have a new message from ${newMessageFromMatch[1].trim()}.`;
  }

  const isMessageEvent = type === 'newmessage' || type.includes('message');
  const templateKeywords =
    /question|liked|meeting|calendar|chat request|profile access|reference|accepted|declined/i;

  const looksLikeRawChat =
    Boolean(sender) &&
    message.length > 0 &&
    !templateKeywords.test(message) &&
    !/^you have a new message from /i.test(message) &&
    !/^new message from /i.test(message);

  if (isMessageEvent || looksLikeRawChat) {
    return sender ? `You have a new message from ${sender}.` : 'You have a new message.';
  }

  return message;
}
